export const DEACTIVATION_INSTRUCTIONS = [
 "PROFILE.DELETE-ACCOUNT.DEACTIVATE_MODAL_ITEM_1",
 "PROFILE.DELETE-ACCOUNT.DEACTIVATE_MODAL_ITEM_2",
 "PROFILE.DELETE-ACCOUNT.DEACTIVATE_MODAL_ITEM_3",
 "PROFILE.DELETE-ACCOUNT.DEACTIVATE_MODAL_ITEM_4",
 "PROFILE.DELETE-ACCOUNT.DEACTIVATE_MODAL_ITEM_5",
 "PROFILE.DELETE-ACCOUNT.DEACTIVATE_MODAL_ITEM_6",

]